import {
  FacilityKbn,
  FacilityKind,
  formClassFacility,
  FormKbn,
} from "../../../assets/data/Constants";
import TkDownloadLink from "../../../components/atoms/TkDownloadLink";
import {
  FacilityList,
  FormList,
} from "../../../type/contextType/businessContext/IJob_15";
import { TkGetCode } from "../../../utils/TkGetCode";
import { changeAmountFormat } from "../../../utils/useTools";

function funInfoBodyList(list: FacilityList[], formList: FormList[]) {
  const bodyList = list?.map((item) => {
    let documentaryEvidence = formList.find(
      (file) =>
        file.formKbn === FormKbn["施設書類"] &&
        file.formClass ===
          formClassFacility["当該施設・事業を経営している証拠書類"] &&
        file.facilityNo === item.facilityNo
    );
    return [
      {
        children: (item.facilityNo ?? "") + ":" + (item?.facilityName ?? ""), // 施設名称
      },
      {
        children: FacilityKind[item.facilityKind as keyof typeof FacilityKind], // 施設種類
      },
      {
        children: TkGetCode(FacilityKbn, item.facilityKbn), // 施設区分
      },
      {
        children: changeAmountFormat(item.admissionCapacityNum ?? 0), // 入所定員（利用定員）
        align: "right",
      },
      {
        children: changeAmountFormat(item.staffBaseNum ?? 0), // 職員配置基準数
        align: "right",
      },
      {
        children: changeAmountFormat(item.totalStaffNum ?? 0), // 職員総数
        align: "right",
      },
      {
        children: changeAmountFormat(item.joinStaffNum ?? 0), // 加入職員数
        align: "right",
      },
      {
        children: changeAmountFormat(item.yearJoindisableStaffNum ?? 0), // 雇用期間1年未満職員数
        align: "right",
      },
      {
        children: changeAmountFormat(item.timeJoindisableStaffNum ?? 0), // 労働時間2/3未満職員数
        align: "right",
      },
      {
        children: documentaryEvidence ? (
          <TkDownloadLink
            dataname={documentaryEvidence.fileName ?? ""}
            base64filedata={documentaryEvidence.fileBase64 ?? ""}
            downloadBase64
          />
        ) : null,
      },
    ];
  });

  return bodyList;
}

export { funInfoBodyList };
